var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "section" }, [
    !_vm.showEndusers
      ? _c(
          "div",
          { staticClass: "container is-fluid" },
          [
            _c("div", { staticClass: "columns is-multiline" }, [
              _c("div", { staticClass: "column is-narrow" }, [
                _c("div", { staticClass: "card custom-card" }, [
                  _c("header", { staticClass: "card-header" }, [
                    _c(
                      "p",
                      { staticClass: "card-header-title has-text-grey" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(`${_vm.localeRoot}.review_card.title`)
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "card-content" }, [
                    _c("div", { staticClass: "content" }, [
                      _c("dl", [
                        _c(
                          "dt",
                          [
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    `${_vm.localeRoot}.review_card.content`
                                  ) + " "
                                )
                              ),
                            ],
                            _c("strong", [
                              _vm._v(_vm._s(_vm.shippingsWithoutConsignee)),
                            ]),
                          ],
                          2
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "columns" }, [
              _c("div", { staticClass: "column" }, [
                _c(
                  "div",
                  { staticClass: "buttons" },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: {
                          type: "is-link",
                          "icon-left": "plus",
                          size: "is-small",
                          outlined: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.showEditForm(null)
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                `${_vm.localeRoot}.date_table.new_shipping`
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "b-button",
                      {
                        attrs: {
                          type: "is-primary",
                          "icon-left": "user-friends",
                          size: "is-small",
                          outlined: "",
                        },
                        on: {
                          click: function ($event) {
                            _vm.showEndusers = true
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(`${_vm.localeRoot}.date_table.my_endusers`)
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "b-button",
                      {
                        attrs: {
                          type: "is-info",
                          "icon-left": "file-import",
                          size: "is-small",
                          outlined: "",
                        },
                        on: {
                          click: function ($event) {
                            _vm.importingShipping = true
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                `${_vm.localeRoot}.date_table.import_shipping`
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "b-button",
                      {
                        attrs: {
                          tag: "router-link",
                          to: "/shippingFileManagement",
                          type: "is-info",
                          "icon-left": "file",
                          size: "is-small",
                          outlined: "",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                `${_vm.localeRoot}.date_table.shipping_file_management`
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "right-align" }, [
                _c(
                  "div",
                  { staticClass: "buttons" },
                  [
                    _c(
                      "div",
                      { staticStyle: { position: "relative" } },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              type: "is-success",
                              "icon-left": "magic",
                              size: "is-small",
                            },
                            on: {
                              click: function ($event) {
                                _vm.autoAssigning = true
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    `${_vm.localeRoot}.date_table.auto_assign`
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c("span", { staticClass: "notif" }, [
                          _vm._v(_vm._s(_vm.autoAssignObject.length)),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "b-button",
                      {
                        attrs: {
                          type: "is-link",
                          "icon-left": "sync",
                          size: "is-small",
                        },
                        on: {
                          click: function ($event) {
                            _vm.getData()
                            _vm.filteredShippings = []
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(`${_vm.localeRoot}.date_table.refresh`)
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _c("ag-grid-vue", {
              staticClass: "ag-theme-alpine",
              staticStyle: { width: "100%", height: "1000px" },
              attrs: {
                "grid-options": _vm.gridOptions,
                pagination: true,
                "pagination-auto-page-size": true,
                modules: _vm.modules,
                "cache-overflow-size": 0,
              },
            }),
            _c(
              "b-modal",
              {
                attrs: {
                  active: _vm.autoAssigning,
                  scroll: "keep",
                  "has-modal-card": "",
                  "on-cancel": _vm.getData,
                },
                on: {
                  "update:active": function ($event) {
                    _vm.autoAssigning = $event
                  },
                },
              },
              [
                _c("autoAssign", {
                  attrs: { "auto-assign-object": _vm.autoAssignObject },
                }),
              ],
              1
            ),
            _c(
              "b-modal",
              {
                attrs: {
                  active: _vm.isCreating,
                  scroll: "keep",
                  "has-modal-card": "",
                  "on-cancel": _vm.getData,
                },
                on: {
                  "update:active": function ($event) {
                    _vm.isCreating = $event
                  },
                },
              },
              [
                _c("ShippingForm", {
                  attrs: {
                    endusers: _vm.endusers,
                    "editable-shipping": null,
                    "is-submitting": _vm.isSubmitting,
                    "dynamic-fields": _vm.dynamicFields,
                  },
                  on: {
                    submit: _vm.submitCreateShipping,
                    moveToNewShipping: _vm.moveToNewShipping,
                  },
                }),
              ],
              1
            ),
            _c(
              "b-modal",
              {
                attrs: {
                  active: _vm.isEditing,
                  scroll: "keep",
                  "has-modal-card": "",
                  "on-cancel": _vm.getData,
                },
                on: {
                  "update:active": function ($event) {
                    _vm.isEditing = $event
                  },
                },
              },
              [
                _c("ShippingForm", {
                  attrs: {
                    endusers: _vm.endusers,
                    "editable-shipping": _vm.editableShipping,
                    "dynamic-fields": _vm.dynamicFields,
                    "is-submitting": _vm.isSubmitting,
                  },
                  on: {
                    submit: _vm.submitUpdateShipping,
                    moveToNewShipping: _vm.moveToNewShipping,
                  },
                }),
              ],
              1
            ),
            _c(
              "b-modal",
              {
                attrs: {
                  active: _vm.importingShipping,
                  scroll: "keep",
                  "has-modal-card": "",
                  "on-cancel": () => {
                    _vm.file = null
                  },
                },
                on: {
                  "update:active": function ($event) {
                    _vm.importingShipping = $event
                  },
                },
              },
              [
                _c("div", [
                  _c(
                    "div",
                    {
                      staticClass: "modal-card",
                      staticStyle: { "min-height": "300px" },
                    },
                    [
                      _c("header", { staticClass: "modal-card-head" }, [
                        _c("p", { staticClass: "modal-card-title" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(`${_vm.localeRoot}.import_modal.title`)
                              ) +
                              " "
                          ),
                        ]),
                      ]),
                      _c("section", { staticClass: "modal-card-body" }, [
                        _c(
                          "div",
                          { staticClass: "center" },
                          [
                            _c(
                              "b-field",
                              { staticClass: "file" },
                              [
                                _c(
                                  "b-upload",
                                  {
                                    model: {
                                      value: _vm.file,
                                      callback: function ($$v) {
                                        _vm.file = $$v
                                      },
                                      expression: "file",
                                    },
                                  },
                                  [
                                    _c(
                                      "a",
                                      { staticClass: "button is-primary" },
                                      [
                                        _c("b-icon", {
                                          attrs: { icon: "upload" },
                                        }),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                `${_vm.localeRoot}.import_modal.import`
                                              )
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm.file
                                  ? _c("span", { staticClass: "file-name" }, [
                                      _vm._v(" " + _vm._s(_vm.file.name) + " "),
                                    ])
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("footer", { staticClass: "modal-card-foot" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button is-fullwidth",
                            on: {
                              click: function ($event) {
                                _vm.importingShipping = false
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(`${_vm.localeRoot}.import_modal.close`)
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "button is-info is-fullwidth",
                            class: { "is-loading": _vm.isSubmitting },
                            attrs: { type: "submit" },
                            on: { click: _vm.submitImportShipping },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    `${_vm.localeRoot}.import_modal.submit`
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]
            ),
            _c(
              "b-modal",
              {
                attrs: {
                  active: _vm.settingEnduser,
                  scroll: "keep",
                  "has-modal-card": "",
                },
                on: {
                  "update:active": function ($event) {
                    _vm.settingEnduser = $event
                  },
                },
              },
              [
                _c("div", [
                  _c(
                    "div",
                    {
                      staticClass: "modal-card",
                      staticStyle: { "min-height": "600px" },
                    },
                    [
                      _c("header", { staticClass: "modal-card-head" }, [
                        _c("p", { staticClass: "modal-card-title" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  `customer.shipping_management.set_enduser_modal.title`
                                )
                              ) +
                              " "
                          ),
                        ]),
                      ]),
                      _c("section", { staticClass: "modal-card-body" }, [
                        _c(
                          "div",
                          [
                            _c(
                              "b-field",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    `${_vm.localeRoot}` +
                                      ".edit_modal.consignee"
                                  ),
                                },
                              },
                              [
                                _c("multiselect", {
                                  staticClass: "z-9",
                                  attrs: {
                                    options: _vm.endusers,
                                    multiple: false,
                                    "close-on-select": true,
                                    "clear-on-select": true,
                                    "allow-empty": true,
                                    "preserve-search": true,
                                    placeholder: "Pick consignee...",
                                    "custom-label": (enduser) => {
                                      return (
                                        enduser.partnerReference +
                                        " - " +
                                        enduser.name +
                                        " | " +
                                        enduser.city +
                                        " - " +
                                        enduser.country
                                      )
                                    },
                                    "track-by": "name",
                                  },
                                  model: {
                                    value: _vm.settedEnduser,
                                    callback: function ($$v) {
                                      _vm.settedEnduser = $$v
                                    },
                                    expression: "settedEnduser",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("footer", { staticClass: "modal-card-foot" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button is-fullwidth",
                            on: {
                              click: function ($event) {
                                _vm.settingEnduser = false
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t(`global.close`)) + " ")]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "button is-info is-fullwidth",
                            class: { "is-loading": _vm.submittingSetEnduser },
                            attrs: { type: "submit" },
                            on: { click: _vm.submitSetEnduser },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t(`global.submit`)) + " ")]
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]
            ),
          ],
          1
        )
      : _c(
          "div",
          [
            _c("enduserList", {
              attrs: {
                endusers: _vm.endusers,
                "hide-enduser-list": _vm.hideEnduserList,
              },
            }),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }